import { applicationManager } from '@round/api';
import { Badge, assets } from '@round/whitelabel-ui';
import styles from './ApplicationBadge.module.css';
import cn from 'classnames';
import { HTMLProps } from 'react';

const { LogoShort: RoundLogo, MicrowaveShort: MicroWavLogo } = assets;

type Application = Exclude<applicationManager.Application, 'creatorbase'>;

export const AppIcon = ({ application, ...props }: HTMLProps<SVGSVGElement> & { application: Application }) => {
    const AppIcon = logos[application];
    return <AppIcon title={application} {...props} />;
};

const logos: Record<Application, typeof RoundLogo> = {
    microwave: MicroWavLogo,
    round: RoundLogo,
};

const labels: Record<Application, string> = {
    microwave: 'Micro.wav',
    round: 'Round',
};

type Props = {
    application: Application;
    className?: string;
};

const ApplicationBadge = ({ application, className }: Props) => {
    return (
        <Badge className={cn(styles.badge, className)}>
            <span className={styles.iconContainer}>
                <AppIcon className={styles.icon} application={application} />
            </span>
            <span>{labels[application]}</span>
        </Badge>
    );
};

export default ApplicationBadge;
